// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "1940ec08f42dcf0a6a61" + ".chunk.js";
};